/**
 * @author silence
 * @desc:注册登录页面请求借口
 * */

import request from '@/utils/ajax';

export function login(data) {
	return request({
		url: 'pms/crm/login',
		method: 'post',
		data,
	});
}

export function initData(url, params) {
  return request({
    url: url,
    method: 'get',
    params
  })
}

export function getDictListByType(data) {
  return request({
    url: '/pms/fp/getDictListByType',
    method: 'get',
    params: data,
  });
}
